import { Box, drawerClasses } from "@vividtheory/minerva-lab";
import { BreakpointSwapper, Drawer, FlexScrollArea, FlexScrollAreaContainer, } from "../components";
import React from "react";
export const MainLayout = ({ children, banner, hideHeader, hideSidebar, mainSidebar, header, setSidebarOpen, sidebarOpen, }) => {
    return (React.createElement(Box, { sx: {
            height: "100dvh",
            width: "100%",
            containerType: "inline-size",
            minWidth: 0,
            display: "flex",
            background: (theme) => theme.palette.background.container,
            color: (theme) => theme.palette.background.onContainer,
            [`& .${drawerClasses.backdrop}`]: {
                zIndex: (theme) => theme.zIndex.drawer + 50,
            },
        } },
        React.createElement(FlexScrollAreaContainer, { width: "100%" },
            banner,
            React.createElement(FlexScrollArea, { width: "100%" },
                React.createElement(BreakpointSwapper, { sx: {
                        height: "100%",
                    }, desktop: !hideSidebar ? (React.createElement(Box, { sx: {
                            height: "100%",
                            borderRight: 1,
                            borderColor: (theme) => theme.palette.stroke[100],
                            padding: 2,
                        } },
                        React.createElement(Box, { sx: {
                                height: "100%",
                                width: 50,
                                background: (theme) => theme.palette.background.main,
                                color: (theme) => theme.palette.background.onMain,
                                borderRadius: (theme) => theme.radius.default,
                            } }, mainSidebar))) : undefined, mobile: !hideSidebar ? (React.createElement(Drawer, { size: 67.5, placement: "left", open: sidebarOpen, onOpenChange: (open) => setSidebarOpen(open), sx: {
                            padding: 2,
                        } },
                        React.createElement(Box, { sx: {
                                height: "100%",
                                width: "100%",
                                borderRadius: (theme) => theme.radius.default,
                                backgroundColor: (theme) => theme.palette.background.main,
                            } }, mainSidebar))) : undefined }),
                React.createElement(FlexScrollAreaContainer, { flex: 1 },
                    hideHeader ? null : (React.createElement(Box, { sx: {
                            width: "100%",
                            borderBottom: 1,
                            borderColor: (theme) => theme.palette.stroke[100],
                            padding: 4,
                        } }, header)),
                    React.createElement(FlexScrollArea, { sx: {
                            width: "100%",
                            minWidth: 0,
                        } }, children))))));
};
//# sourceMappingURL=MainLayout.js.map